import { OrganizationKeyName } from "../../../model/Organization";

export const GET_ORDER_FAIL = "SHOP:GET_ORDER_FAIL";

export const getOrderFailAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_ORDER_FAIL as typeof GET_ORDER_FAIL,
  organization,
  id,
});

export type GetOrderFailAction = ReturnType<typeof getOrderFailAction>;
